<template>
  <div class="login container">

    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>

    <form v-else @submit.prevent="submit">



      <div class="d-flex justify-content-between">
        <div class="col-xs-6 pl-3 pt-5">
          <cta type="button" @click="navBack()" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>
        <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" margin="no-margin" :loading="submitted" />
        </div>
        </div>

        <div class="row">
        <h2 class="col-md-12 pt-2">Send receipt to</h2>
        </div>
        <div class="row">
        <h3 class="col-md-12 pt-2">(Optional)</h3>
        </div>


        <div class="row d-flex justify-content-center">
            <div class="text-input-holder col-sm-12 pt-4 size-limit">
                <input type="text" v-model="receipt_email" name="receipt_email" placeholder="Enter email address" v-validate="'email'" />
                <p class="is-danger" v-if="errors.has('receipt_email')">{{errors.first('receipt_email')}}</p>
            </div>
        </div>

        
   

      <div class="row d-flex justify-content-center" v-if="orderPayload.digitalJourney">
            <cta type="button" class="col-sm-12 pt-4 size-limit d-flex justify-content-center" size="small" text="This is the same as previous card email" @click="replicateEmail" />
      </div>
    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
          submitted     : false,
          receipt_email : '',
          variables     : {}
      };
  },
  created:function(){
        this.init();
  },
  computed: {

    account(){
      return this.$store.getters.getAccount;
    },

    unit(){
      return this.$store.getters.getUnit;
    },

    accountCurrency(){
      return this.$store.getters.getAccountCurrency;
    },

    orderPayload(){
      return this.$store.getters.getOrderPayload;
    },

    digitalOrder() {
        let variables = {
            account_id              : this.account.id,
            sales_channel_id        : 3, // in store
            order_items             : [
                {
                    product_id : this.orderPayload.product.id,
                    fulfilment_method_id : 1, // email
                }
            ],
            currency                : this.accountCurrency.iso_currency_code,
            group_fulfilment        : true,
            group_fulfilment_email  : this.orderPayload.email,
            unit_id                 : this.unit.id,
        }

        if(this.orderPayload.customPriceModifier){
            variables.order_items[0].custom_price_modifier_value = this.orderPayload.custom_price_modifier_value;
            variables.total = this.orderPayload.custom_price_modifier_value;
        }
        else if(this.orderPayload.price_modifier){
            variables.order_items[0].price_modifier_id = this.orderPayload.price_modifier.id
            variables.total = this.orderPayload.price_modifier.price;
        }

        if (this.receipt_email != '')  variables.receipt_email = this.receipt_email

        if(typeof this.orderPayload.note !== 'undefined')
            variables.note = this.orderPayload.note;

        if(this.orderPayload.payment == 'foc') {
            variables.order_items[0].discounts = [{
                discount_type_id : 1 //FOC
            }];

            if(this.orderPayload.customPriceModifier){
                variables.order_items[0].discounts[0].value = this.orderPayload.custom_price_modifier_value;
            }
            else if(this.orderPayload.price_modifier){
                variables.order_items[0].discounts[0].value = this.orderPayload.price_modifier.price;
            }

            variables.total = 0;
        }

        return variables;
    },

    physicalOrder() {
        let variables = {
            account_id              : this.account.id,
            sales_channel_id        : 3, // in store
            order_items             : [
                {
                    product_id : this.orderPayload.product.id,
                    fulfilment_method_id : 3, // in venue purchase
                }
            ],
            currency                : this.accountCurrency.iso_currency_code,
            group_fulfilment        : true,
            unit_id                 : this.unit.id,
        }

        if(this.orderPayload.customPriceModifier){
            variables.order_items[0].custom_price_modifier_value = this.orderPayload.custom_price_modifier_value;
            variables.total = this.orderPayload.custom_price_modifier_value;
        }
        else if(this.orderPayload.price_modifier){
            variables.order_items[0].price_modifier_id = this.orderPayload.price_modifier.id
            variables.total = this.orderPayload.price_modifier.price;
        }

        if (this.receipt_email != '')  variables.receipt_email = this.receipt_email

        if(typeof this.orderPayload.unique_code !== 'undefined')
            variables.order_items[0].card_reference = this.orderPayload.unique_code;

        if(typeof this.orderPayload.note !== 'undefined')
            variables.note = this.orderPayload.note;

        if(this.orderPayload.payment == 'foc') {
            variables.order_items[0].discounts = [{
                discount_type_id : 1 //FOC
            }];

            if(this.orderPayload.customPriceModifier){
                variables.order_items[0].discounts[0].value = this.orderPayload.custom_price_modifier_value;
            }
            else if(this.orderPayload.price_modifier){
                variables.order_items[0].discounts[0].value = this.orderPayload.price_modifier.price;
            }

            variables.total = 0;
        }
        
        return variables;
    },

  },
  watch:{

   
  },
  mounted: function(){

  },
  methods:{

    init(){
        if(typeof this.orderPayload.receipt_email !== 'undefined') {
            this.receipt_email = this.orderPayload.receipt_email;
        }
    },

    replicateEmail() {
        this.receipt_email = this.orderPayload.email;
    },

    createOrder() {
        
        this.submitted = true;

        window.axios({
            url: process.env.VUE_APP_API_GRAPH_URL,
            method: 'post',
            data: {
            query: `mutation(
                    $account_id                      :Int!, 
                    $unit_id                         :Int,
                    $sales_channel_id                :Int!, 
                    $order_items                     :[OrderItemInput]!, 
                    $currency                        :String!, 
                    $group_fulfilment                :Boolean!,
                    $group_fulfilment_email          :String,
                    $total                           :Int!,
                    $note                            :String,
                    $discounts                       :[DiscountInput],
                    $receipt_email                   :String,
                ){
                    createOrder(
                        account_id                      : $account_id,
                        unit_id                         : $unit_id,
                        sales_channel_id                : $sales_channel_id,
                        order_items                     : $order_items,
                        currency                        : $currency,
                        group_fulfilment                : $group_fulfilment,
                        group_fulfilment_email          : $group_fulfilment_email,
                        total                           : $total,
                        note                            : $note,
                        discounts                       : $discounts,
                        receipt_email                   : $receipt_email,
                        restrict_pos_units             : true
                    ) 
                    {
                        id,
                        LineItems {
                            Card {
                                card_reference,pin,expiry_time,validity_start_time
                            }
                        }
                    }
                }`,
                variables: this.variables
            }
        }).then((result) => {

            let error_to_error = {
                'order_items.0.card_reference':'unique_code',
                'unit_id':'unit_id'
            }

            this.validateGraphResponse(result,error_to_error);

            if (this.errors.has('unique_code')) {

                this.$router.push({ name: 'gift-unique-code'});
                
            } else if (this.errors.has('unit_id')) {

                this.$bus.$emit('error_message', result.data.errors[0].validation.unit_id[0]);
                
            } else if (result.data.data && result.data.data.createOrder.LineItems.length){
                
                const card = result.data.data.createOrder.LineItems[0].Card;
                
                this.$set(this.orderPayload, 'card', card);
                this.$store.commit("ORDER_PAYLOAD",this.orderPayload);
                
                this.$router.push({ name: 'sell-success'});
            } else {
                this.errors.add({field:'receipt_email',msg:'Error creating order'});
            }
        }).then(() => {
            this.submitted = false;
        });
    },

    submit()
    {

        this.$validator.validateAll().then((result) => {
          if(result){

            if(this.orderPayload.digitalJourney)
                this.variables = this.digitalOrder;

            if(this.orderPayload.physicalJourney)
                this.variables = this.physicalOrder;

            this.createOrder();
            
          }
        })

    },

    navBack() {

        if(this.orderPayload.payment == 'foc') {
            this.$router.push({ name: 'foc-reason'});
        } else {
            if(this.orderPayload.digitalJourney) {
                this.$router.push({ name: 'payment'});
            } else {
                if(typeof this.orderPayload.unique_code !== 'undefined') {
                    this.$router.push({ name: 'gift-unique-code'});
                } else {
                    this.$router.push({ name: 'payment'});
                }
            }
        }
    },

  }
}
</script>

<style scoped>

  .select-holder {
    margin-top: 15px;
  }

</style>
